'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { appEnvironment, isProdEnvironment, isQAEnvironment } from 'utils/environment';
import { datadogLogs } from '@datadog/browser-logs';
let isInitialized = false;

const CLIENT_TOKEN = 'pub317a64fae7f026ae28320e9f4ff61dda';

export function DatadogRumInit() {
  useEffect(() => {
    if ((isProdEnvironment() || isQAEnvironment()) && !isInitialized) {
      datadogRum.init({
        applicationId: 'ff55cbb4-68d6-4469-af91-6c9ca257e53b',
        clientToken: CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'chime-com',
        env: appEnvironment,
        allowedTracingUrls: [/https:\/\/.*\.chime\.com/],
        version: process.env.NEXT_PUBLIC_GIT_COMMIT_SHA,
        trackUserInteractions: false,
        trackResources: true,
        trackLongTasks: true,
        sessionSampleRate: 10,
        sessionReplaySampleRate: 0,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend: event => {
          if (event.type === 'error') {
            if (event?.error?.message.startsWith('csp_violation')) {
              // don't log content security policy violations
              return false;
            }
            if (event?.error?.message === 'Uncaught "Script error."') {
              // a generic "Script Error" is logged in the browser console when an uncaught JS error
              // occurs in a file served from a different domain or subdomain, e.g. from third party JS
              return false;
            }
          }
          return true;
        },
      });

      datadogLogs.init({
        clientToken: CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'chime-com',
        env: appEnvironment,
        version: process.env.NEXT_PUBLIC_GIT_COMMIT_SHA,
      });

      datadogRum.startSessionReplayRecording();
      isInitialized = true;
    }
  }, []);

  return null;
}
